import { render, staticRenderFns } from "./TheSourceIcon.vue?vue&type=template&id=b3b8cda6&"
import script from "./TheSourceIcon.vue?vue&type=script&lang=js&"
export * from "./TheSourceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports